module.exports = __webpack_public_path__ + "img/car-image-placeholder.b10f2a5e.jpg";